import { render, staticRenderFns } from "./KpiTrend.vue?vue&type=template&id=3d08614d"
import script from "./KpiTrend.vue?vue&type=script&lang=ts"
export * from "./KpiTrend.vue?vue&type=script&lang=ts"
import style0 from "./KpiTrend.vue?vue&type=style&index=0&id=3d08614d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports